/**
 * Recommended slider script
 */
 class SW_RecommendedSlider {
  constructor() {
    this.initState();
  }

  initState() {
    this.sliderWrapper = $('.recommended');
    
    if (!this.sliderWrapper.length) {
      return;
    }
    
    this.initEvents();
  }

  initEvents() {
    this.initUI();
    this.initRWD();
  }

  initUI () {
    this.list = this.sliderWrapper.find('.recommended-list');
    this.items = this.list.find('.post-archive-item');
    this.nextBtn = this.sliderWrapper.find('.next');
    this.prevBtn = this.sliderWrapper.find('.prev');
    this.currentItem = 0;
    this.itemsPerPage = 3;
    this.animationInProgress = false; 
    this.swipeEffect = new Hammer(this.sliderWrapper[0]);

    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem++;
      this.animationInProgress = true;

      if (this.currentItem === this.items.length - this.itemsPerPage) {
        this.nextBtn.addClass('is-hidden');
      }

      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      this.prevBtn.removeClass('is-hidden');

      setTimeout(() => {
        this.animationInProgress = false;
      }, 250);
    });

    this.prevBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem--;
      this.animationInProgress = true;

      if (this.currentItem === 0) {
        this.prevBtn.addClass('is-hidden');
      }

      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      this.nextBtn.removeClass('is-hidden');

      setTimeout(() => {
        this.animationInProgress = false;
      }, 250);
    });

    this.swipeEffect.on('swipe', ev => {
      if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
        if (this.currentItem === this.items.length - this.itemsPerPage) {
          return
        } else {
          this.nextBtn.trigger('click');
        }
      }

      if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
        if (this.currentItem === 0) {
          return
        } else {
          this.prevBtn.trigger('click');
        }
      }
    });
  }

  initRWD () {
    this.desktopViewport = window.matchMedia('(min-width: 841px)');
    this.tabletViewport = window.matchMedia('(min-width: 560px) and (max-width: 840px)');
    this.mobileViewport = window.matchMedia('(max-width: 559px)');
    if (this.desktopViewport.matches) this.updateViewports('desktop');
    if (this.tabletViewport.matches) this.updateViewports('tablet');
    if (this.mobileViewport.matches) this.updateViewports('mobile');
    this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
    this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
    this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);


    if (this.desktopViewport.matches) {
      this.itemsPerPage = 3;
      this.nextBtn.removeClass('is-hidden');
      this.prevBtn.addClass('is-hidden');
    } else if (this.tabletViewport.matches) {
      this.itemsPerPage = 2;
      this.nextBtn.removeClass('is-hidden');
      this.prevBtn.addClass('is-hidden');
    } else if (this.mobileViewport.matches) {
      this.itemsPerPage = 1;
      this.nextBtn.removeClass('is-hidden');
      this.prevBtn.addClass('is-hidden');
    }

    this.desktopViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(3);
        this.nextBtn.removeClass('is-hidden');
        this.prevBtn.addClass('is-hidden');
      }
    });

    this.tabletViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(2);
        this.nextBtn.removeClass('is-hidden');
        this.prevBtn.addClass('is-hidden');
      }
    });

    this.mobileViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(1);
        this.nextBtn.removeClass('is-hidden');
        this.prevBtn.addClass('is-hidden');
      }
    });
  }

  updateViewports (type) {
    if (this.currentViewport !== type) {
      this.currentItem = 0;
      this.list.css('margin-left', "0%");
      this.currentViewport = type;
    }
  }

  setItemsPerPage (numberOfItems) {
    this.currentItem = 0;
    this.itemsPerPage = numberOfItems;
    this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
  }
}